import { Banner, Button, SpreadsheetTable, Wizard } from '@st/theme'
import type { CsvExportState } from './st-folder-list-module'

export function STFolderListExportCsvPage({
  exportState,
  send,
  emailsManagedBy,
  onClose,
  onClickBack
}: {
  exportState: CsvExportState
  send: (
    message: { type: 'downloadCsvExport' } | { type: 'requestCsvExport'; folderIds: string[] }
  ) => void
  emailsManagedBy: 'stanfordtax' | 'karbon'
  onClose: () => void
  onClickBack: () => void
}) {
  function onPressDownloadCSV() {
    if (exportState.status != 'loaded') {
      throw new Error('Failed to download CSV')
    }

    send({ type: 'downloadCsvExport' })
  }

  return (
    <Wizard.Scaffold
      breadcrumb="Export CSV"
      onClose={onClose}
      bottomNav={
        <Wizard.BottomNav>
          <Button variant="default" onClick={onClickBack}>
            Back
          </Button>
          <Button
            variant="primary"
            onClick={onPressDownloadCSV}
            disabled={exportState.status != 'loaded'}
          >
            Download CSV
          </Button>
        </Wizard.BottomNav>
      }
    >
      <Wizard.Main
        title="Export CSV"
        subtitle="Export organizer links for the selected clients to use in a mail merge or another delivery tool."
        banner={
          emailsManagedBy == 'karbon' && (
            <Banner variant="info" className="sticky top-0 w-full rounded-none">
              The links below take clients directly to their organizer. You can send clients to
              their Karbon for Clients portal from Karbon instead.
            </Banner>
          )
        }
        variant="wide"
      >
        {exportState.status == 'failed' ? (
          <div className="mb-4 flex items-center justify-between gap-4 rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">
            <span>Failed to load CSV data.</span>
            <Button
              variant="default"
              onClick={() => send({ type: 'requestCsvExport', folderIds: exportState.folderIds })}
            >
              Retry
            </Button>
          </div>
        ) : null}

        <SpreadsheetTable className="w-full">
          <SpreadsheetTable.Head>
            <SpreadsheetTable.Th>Email address</SpreadsheetTable.Th>
            <SpreadsheetTable.Th>Client</SpreadsheetTable.Th>
            <SpreadsheetTable.Th>Assignees</SpreadsheetTable.Th>
            <SpreadsheetTable.Th>Salutation</SpreadsheetTable.Th>
            <SpreadsheetTable.Th>Entity name</SpreadsheetTable.Th>
            <SpreadsheetTable.Th>Return type</SpreadsheetTable.Th>
            <SpreadsheetTable.Th>Tax year</SpreadsheetTable.Th>
            <SpreadsheetTable.Th>Organizer link</SpreadsheetTable.Th>
            <SpreadsheetTable.Th>Organizer status</SpreadsheetTable.Th>
            <SpreadsheetTable.Th>Source</SpreadsheetTable.Th>
            <SpreadsheetTable.Th>Source ID</SpreadsheetTable.Th>
          </SpreadsheetTable.Head>
          <SpreadsheetTable.Body>
            {exportState.status == 'loaded'
              ? exportState.data.rows.map((row, index) => (
                  <SpreadsheetTable.Row key={index}>
                    <SpreadsheetTable.Cell>{row.emails}</SpreadsheetTable.Cell>
                    <SpreadsheetTable.Cell>{row.client}</SpreadsheetTable.Cell>
                    <SpreadsheetTable.Cell>{row.assignees}</SpreadsheetTable.Cell>
                    <SpreadsheetTable.Cell>{row.salutation}</SpreadsheetTable.Cell>
                    <SpreadsheetTable.Cell>{row.entity}</SpreadsheetTable.Cell>
                    <SpreadsheetTable.Cell>{row.returnType}</SpreadsheetTable.Cell>
                    <SpreadsheetTable.Cell>{row.taxYear}</SpreadsheetTable.Cell>
                    <SpreadsheetTable.Cell>{row.questionnaireLink}</SpreadsheetTable.Cell>
                    <SpreadsheetTable.Cell>{row.questionnaireStatus}</SpreadsheetTable.Cell>
                    <SpreadsheetTable.Cell>{row.source}</SpreadsheetTable.Cell>
                    <SpreadsheetTable.Cell>{row.sourceId}</SpreadsheetTable.Cell>
                  </SpreadsheetTable.Row>
                ))
              : null}
          </SpreadsheetTable.Body>
        </SpreadsheetTable>
      </Wizard.Main>
    </Wizard.Scaffold>
  )
}
